import { lazy, Suspense, useEffect } from 'react';
import { App as AntApp, ConfigProvider } from 'antd';
import { useSettingsStore } from './stores/settingsStore';
import { AppPageLoader, StyledEmpty } from './components/feedback';
import { createAppTheme } from './app/theme/createAppTheme';
import { useAuthenticatedSessionOrchestration } from './app/session/useAuthenticatedSessionOrchestration';
import { isBroadcastPath } from './utils/streamOverlay';

const ManagementRouter = lazy(() => import('./app/router/ManagementRouter'));

function App() {
  const themeMode = useSettingsStore((state) => state.theme);
  const appTheme = createAppTheme(themeMode);
  useAuthenticatedSessionOrchestration();

  useEffect(() => {
    document.documentElement.setAttribute('data-ys-theme', themeMode);

    return () => {
      document.documentElement.removeAttribute('data-ys-theme');
    };
  }, [themeMode]);

  return (
    <ConfigProvider
      theme={appTheme}
      componentSize="small"
      renderEmpty={(componentName) => (
        <StyledEmpty
          title={componentName === 'Table' ? 'No rows yet' : 'No content yet'}
          description="Try adjusting filters or come back later."
        />
      )}
    >
      <AntApp>
        <Suspense fallback={isBroadcastPath(window.location.pathname) ? null : <AppPageLoader />}>
          <ManagementRouter />
        </Suspense>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
